// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyB9AdIq4mVRcvQogyXWb_ncqY-SAnRv6MY",
  authDomain: "affiliamate-781e6.firebaseapp.com",
  databaseURL: "https://affiliamate-781e6-default-rtdb.firebaseio.com",
  projectId: "affiliamate-781e6",
  storageBucket: "affiliamate-781e6.firebasestorage.app",
  messagingSenderId: "484539299545",
  appId: "1:484539299545:web:b4c5b72dbb04f5868ef0c8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
